import React from "react";
import { motion } from "framer-motion";
import "./News.css";
import { news } from "../../data";
import Reveal from "../motion/Reveal";
import { staggerContainer, staggerItem } from "../motion/variants";

const News = () => {
  return (
    <Reveal as="section" id="highlights">
      <h5 className="title">Worth a Look</h5>
      <h2>Highlights</h2>

      {/* Highlight cards grid */}
      <motion.div
        className="container news__container"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: "some" }}
        variants={staggerContainer}
      >
        {news.map(({ id, cover, title, keywords, link }) => {
          return (
            <motion.div key={id} className="card" variants={staggerItem} whileHover={{ y: -6 }}>
              <div>
                <div className="thumb">
                  <img src={cover} alt={title} />
                </div>
                <div className="content">
                  <a href={link} target="_blank" rel="noreferrer">{title}</a>
                <ul className="tags">
                  {keywords.map((keyword, index) => (
                    <li className="tag" key={index}>
                      #{keyword}
                    </li>
                  ))}
                </ul>
                </div>

              </div>
            </motion.div>
          );
        })}
      </motion.div>
    </Reveal>
  );
};

export default News;
